import * as Icons from "lucide-react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { SOURCING_RISKS, RISK_FLOW } from "@/data/content";

export const WhyVerification = () => {
  return (
    <section id="why-verification" data-testid="why-verification-section" className="relative py-24 sm:py-32 bg-[#F8F9FB] border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>Why Verification Matters</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-tight text-slate-900">
              Not every supplier is ready for global business.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Sourcing internationally exposes buyers to risks that are hard to see from a listing or a quote. Verification removes the guesswork.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {SOURCING_RISKS.map((risk, i) => {
            const Icon = Icons[risk.icon] || Icons.AlertCircle;
            return (
              <Reveal key={risk.title} delay={i * 0.05}>
                <div data-testid={`risk-card-${i}`} className="h-full bg-white border border-slate-200/80 rounded-2xl sm:rounded-3xl p-6 sm:p-7 transition-all duration-300 hover:shadow-[0_20px_40px_rgba(15,23,42,0.08)] hover:-translate-y-1 hover:border-slate-200">
                  <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-amber-50 text-amber-600 border border-amber-100"><Icon className="w-5 h-5" /></span>
                  <h3 className="mt-5 text-lg font-semibold text-slate-900">{risk.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{risk.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 rounded-3xl border border-slate-200/80 bg-white p-6 sm:p-10">
            <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 md:gap-2 justify-between">
              {RISK_FLOW.map((node, i) => (
                <div key={node.label} className="flex flex-col md:flex-row items-center gap-3 md:gap-2 md:flex-1">
                  <div className={`w-full md:w-auto flex-1 text-center px-4 py-3.5 rounded-xl border text-sm font-semibold ${node.tone === "verified" ? "bg-emerald-50 text-emerald-700 border-emerald-100" : "bg-slate-50 text-slate-600 border-slate-200"}`}>
                    {node.label}
                  </div>
                  {i < RISK_FLOW.length - 1 && (
                    <>
                      <ArrowRight className="hidden md:block w-4 h-4 text-slate-300 shrink-0" />
                      <ArrowDown className="md:hidden w-4 h-4 text-slate-300" />
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default WhyVerification;
